// Mock data for Revaluation transactions
// Centralized location for demo mode data

export interface RevaluationBatchSummary {
  id: string;
  batchReference: string;
  date: string;
  dateOfRun: string;
  amount: number;
  totalAdjustment: number;
  assets: number;
  assetCount: number;
  status: string;
  notes: string;
  preparedBy: string;
  preparedDate: string;
  postedBy?: string;
  postedDate?: string;
}

export const mockRevaluationBatches: RevaluationBatchSummary[] = [
  // Recent batches - various statuses
  { 
    id: 'REV-2025-003', 
    batchReference: 'REV-2025-003',
    date: '2025-11-20', 
    dateOfRun: '2025-11-20',
    amount: 28500.00, 
    totalAdjustment: 28500.00,
    assets: 8, 
    assetCount: 8,
    status: 'Pending Approval',
    notes: 'Q4 2025 property revaluation - market value adjustment',
    preparedBy: 'John Smith',
    preparedDate: '2025-11-20T09:30:00',
  },
  { 
    id: 'REV-2025-002', 
    batchReference: 'REV-2025-002',
    date: '2025-11-10', 
    dateOfRun: '2025-11-10',
    amount: -4200.00, 
    totalAdjustment: -4200.00,
    assets: 3, 
    assetCount: 3,
    status: 'Posted',
    notes: 'IT equipment impairment - obsolete hardware write-down',
    preparedBy: 'David Wilson',
    preparedDate: '2025-11-10T14:00:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2025-11-10T16:45:00',
  },
  { 
    id: 'REV-2025-001', 
    batchReference: 'REV-2025-001',
    date: '2025-10-25', 
    dateOfRun: '2025-10-25',
    amount: 45000.00, 
    totalAdjustment: 45000.00,
    assets: 2, 
    assetCount: 2,
    status: 'Posted',
    notes: 'Vehicle fleet revaluation - appreciation due to market conditions',
    preparedBy: 'Mike Davis',
    preparedDate: '2025-10-25T10:00:00',
    postedBy: 'Betty Davis',
    postedDate: '2025-10-25T15:30:00',
  },
  // Historical batches
  { 
    id: 'REV-2024-004', 
    batchReference: 'REV-2024-004',
    date: '2024-12-15', 
    dateOfRun: '2024-12-15',
    amount: 112700.00, 
    totalAdjustment: 112700.00,
    assets: 17, 
    assetCount: 17,
    status: 'Posted',
    notes: 'Year-end comprehensive asset revaluation - all categories',
    preparedBy: 'John Smith',
    preparedDate: '2024-12-15T08:00:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2024-12-15T17:00:00',
  },
  { 
    id: 'REV-2024-003', 
    batchReference: 'REV-2024-003',
    date: '2024-09-20', 
    dateOfRun: '2024-09-20',
    amount: 18500.00, 
    totalAdjustment: 18500.00,
    assets: 6, 
    assetCount: 6,
    status: 'Posted',
    notes: 'Q3 machinery revaluation - specialist equipment appreciation',
    preparedBy: 'Michael Chen',
    preparedDate: '2024-09-20T11:00:00',
    postedBy: 'Betty Davis',
    postedDate: '2024-09-20T14:30:00',
  },
  { 
    id: 'REV-2024-002', 
    batchReference: 'REV-2024-002',
    date: '2024-06-10', 
    dateOfRun: '2024-06-10',
    amount: -8900.00, 
    totalAdjustment: -8900.00,
    assets: 4, 
    assetCount: 4,
    status: 'Posted',
    notes: 'Mid-year impairment review - damaged equipment write-down',
    preparedBy: 'Emma Wilson',
    preparedDate: '2024-06-10T09:00:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2024-06-10T12:00:00',
  },
  { 
    id: 'REV-2024-001', 
    batchReference: 'REV-2024-001',
    date: '2024-03-08', 
    dateOfRun: '2024-03-08',
    amount: 25000.00, 
    totalAdjustment: 25000.00,
    assets: 5, 
    assetCount: 5,
    status: 'Posted',
    notes: 'Q1 property revaluation - London HQ building appreciation',
    preparedBy: 'John Smith',
    preparedDate: '2024-03-08T10:00:00',
    postedBy: 'Betty Davis',
    postedDate: '2024-03-08T16:00:00',
  },
  { 
    id: 'REV-2023-002', 
    batchReference: 'REV-2023-002',
    date: '2023-12-20', 
    dateOfRun: '2023-12-20',
    amount: 67500.00, 
    totalAdjustment: 67500.00,
    assets: 12, 
    assetCount: 12,
    status: 'Posted',
    notes: 'Year-end 2023 comprehensive revaluation',
    preparedBy: 'Robert Williams',
    preparedDate: '2023-12-20T08:30:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2023-12-20T17:30:00',
  },
  { 
    id: 'REV-2023-001', 
    batchReference: 'REV-2023-001',
    date: '2023-06-15', 
    dateOfRun: '2023-06-15',
    amount: -12300.00, 
    totalAdjustment: -12300.00,
    assets: 8, 
    assetCount: 8,
    status: 'Posted',
    notes: 'Mid-year 2023 impairment assessment',
    preparedBy: 'Lisa Brown',
    preparedDate: '2023-06-15T09:00:00',
    postedBy: 'Betty Davis',
    postedDate: '2023-06-15T14:00:00',
  },
];
